import React, { useMemo, useState } from 'react';
import { Layout, Card, Button, Input, Radio } from 'antd';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useSelector } from 'react-redux';
import CustomThemeDrawer from '../../../../../Elements/CustomThemeDrawer';

const { Content } = Layout


const alerts = ['e-Mail', 'SMS', 'WhatsApp', 'Mobile App'];
const subCategories = [
  'Daily Report',
  'Monthly Report',
  'Steam Report',
  'Comm Alerts',
  'Data Alerts',
];

const recipientData = Array.from({ length: 9 }, (_, i) => ({
  sno: i + 1,
  recipient: i % 2 === 0 ? 'abc@gmail.com' : 'def@gmail.com',
}));

const DashboardLayout = () => {
      const [open, setOpen] = useState(false); 
      const [open2, setOpen2] = useState(false); 
    
    const showDrawer = () => {
        setOpen(true); 
      };
    
      const onClose = () => {
        setOpen(false);
      };
    const showDrawer2 = () => {
        setOpen2(true);
      };
    
      const onClose2 = () => {
        setOpen2(false);
      };
    const mode = useSelector((state) => state.darkMode);
const color = useSelector((state) => state.ThemeChange);
console.log(color);
const { isdarkMode } = mode;
  const columnDefs = useMemo(
    () => [
      { headerName: 'S.No', field: 'sno', width: 80 },
      { headerName: 'Recipient', field: 'recipient', flex: 1 },
      {
        headerName: 'Energy',
        field: 'energy1',
        cellRenderer: () => <Radio />,
        width: 100,
      },
      {
        headerName: 'Energy',
        field: 'energy2',
        cellRenderer: () => <Radio />,
        width: 100,
      },
      {
        headerName: 'Energy',
        field: 'energy3',
        cellRenderer: () => <Radio />,
        width: 100,
      },
    ],
    []
  );



  return (
<div className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}>
  <div>
    <h2
      className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
        isdarkMode ? "text-white" : "text-black"
      }`}
    >
      Alerts
    </h2>

    <div className="flex  gap-4">
      {/* Alerts */}
      <Card
        title={<span className={isdarkMode ? "text-white" : "text-black"}>Alerts</span>}
        extra={<Button type="primary" onClick={()=>showDrawer()}> Add +</Button>}
        bodyStyle={{ padding: 0 }}
        className={` w-1/4 rounded-md shadow h-[90vh] p-0 ${isdarkMode ? "bg-transparent" : "bg-white"}`}
      >
        <Input.Search placeholder="Search" className="my-3 w-[96%] mx-1" />
        <Radio.Group
          style={{ width: '100%' }}
          className={`flex flex-col gap-2 px-0 border-t-2 ${isdarkMode ? "text-white" : "text-black"}`}
        >
          {alerts.map((item) => (
            <Radio
              key={item}
              value={item}
              className={`${isdarkMode ? "text-white" : "text-black "} w-full py-2 border-b-2 pl-1`}>
              {item}
            </Radio>
          ))}
        </Radio.Group>
      </Card>

      {/* Sub-Category */}
      <Card 
        title={<span className={isdarkMode ? "text-white" : "text-black "}>Sub-Category</span>}
        extra={<Button type="primary" onClick={()=>showDrawer2()}>Add +</Button>}
        className={`p-0 w-1/4 rounded-md shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
        bodyStyle={{ padding: 0 }}
      >
        <Input.Search placeholder="Search" className="my-3 w-[96%] mx-1" />

        <Radio.Group
          style={{ width: '100%' }}
          className={`flex flex-col gap-2 px-0 border-t-2  ${isdarkMode ? "text-white" : "text-black"} `}
        >
          {subCategories.map((item) => (
            <Radio
              key={item}
              value={item}
              className={`${isdarkMode ? "text-white" : "text-black "} w-full py-2 border-b-2 pl-1`}
            >
              {item}
            </Radio>
          ))}
        </Radio.Group>
      </Card>

      {/* Recipient with AgGrid */}
      <Card
        title={<span className={isdarkMode ? "text-white" : "text-black"}>Recipient</span>}
        extra={<Button type="primary">Add +</Button>}
        className={`p-0 rounded-md w-2/3 shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
        bodyStyle={{ padding: 0 }}
      >
        <Input.Search placeholder="Search" className="my-3 mx-1 w-[98%]" />

        <div
          className={`ag-theme-alpine${isdarkMode ? "-dark" : ""}`}
          style={{ height: 300, width: '100%' }}
        >
          <AgGridReact
            rowData={recipientData}
            columnDefs={columnDefs}
            domLayout="autoHeight"
          />
        </div>
      </Card>
    </div>
  </div>

  <CustomThemeDrawer
   title="Close"
   showDrawer={showDrawer}
   open={open}
   onClose={onClose}
  >
    <div className="flex flex-col gap-6 mt-2">
        <div>
          <label className="block mb-2 font-medium">
            Alert Name
          </label>
          <Input
            placeholder="Enter alert name"
            // value={alertName}
            // onChange={(e) => setAlertName(e.target.value)}
            className={`${isdarkMode ? 'darkmode-input' : ''}`}
          />
        </div>

        <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
          <Button onClick={onClose} className="">
            Cancel
          </Button>
          <Button
            type="primary"
            // disabled={!alertName.trim()}
            // onClick={handleAdd}
          >
            Add
          </Button>
        </div>
      </div>
  </CustomThemeDrawer>
  <CustomThemeDrawer
   title="Close"
   showDrawer={showDrawer2}
   open={open2}
   onClose={onClose2}
  >
    <div className="flex flex-col gap-6 mt-2">
        <div>
          <label className="block mb-2 font-medium">
            Sub Group
          </label>
          <Input
            placeholder="Enter sub group "
            // value={alertName}
            // onChange={(e) => setAlertName(e.target.value)}
            className={`${isdarkMode ? 'darkmode-input' : ''}`}
          />
        </div>

        <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
          <Button onClick={onClose} className="">
            Cancel
          </Button>
          <Button
            type="primary"
            // disabled={!alertName.trim()}
            // onClick={handleAdd}
          >
            Add
          </Button>
        </div>
      </div>
  </CustomThemeDrawer>
</div>

  );
};

export default DashboardLayout;
